import { render, staticRenderFns } from "./TurntableGame.vue?vue&type=template&id=c347a9c4&scoped=true&"
import script from "./TurntableGame.vue?vue&type=script&lang=js&"
export * from "./TurntableGame.vue?vue&type=script&lang=js&"
import style0 from "./TurntableGame.vue?vue&type=style&index=0&id=c347a9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c347a9c4",
  null
  
)

export default component.exports